import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import FormBuilderService from "services/formBuilder";
import FormBuilderView from "./view";

class FormBuilder extends Component {
  state = {
    fields: [],
    infoModal: false,
  };

  componentDidMount() {}

  setFormData = (type, value) => this.setState({ [type]: value });

  addField = (type) => {
    const fields = this.state.fields;
    this.setState({ fields: [...fields, { title: "", type }] });
  };

  clearFields = () => this.setState({ fields: [] });

  showInfoModal = (infoModal) => this.setState({ infoModal });

  showPreviewModal = (previewModal) => this.setState({ previewModal });

  preview = () => {};

  submit = () => {
    const { fields } = this.state;
    const { history, user } = this.props;

    if (!user.token || user.type !== "company") history.push("/");
    else {
      FormBuilderService.sendForm(fields, user.id).then((res) => {
        console.log(res);
      });
    }
  };

  render() {
    const { fields, infoModal } = this.state;
    return (
      <FormBuilderView
        setFormData={this.setFormData}
        addField={this.addField}
        fields={fields}
        infoModal={infoModal}
        showInfoModal={this.showInfoModal}
        clearFields={this.clearFields}
        submit={this.submit}
        preview={this.preview}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FormBuilder));
